/* OVR product gallery.
   Rebuilds the grid of cropped tiles that the product section renders into a
   slideshow of whole images with thumbnails, and opens any image enlarged.

   Done in script, on the markup that is already there, for two reasons. The
   product section is large and carries the size finder; leaving it alone means
   this cannot break it. And if this file fails to load or throws, the page
   keeps the original grid: every rule in ovr-gallery.css hangs off `.is-gal`,
   which is only added once the build has finished.

   It rebuilds on `shopify:section:load` so the theme editor keeps working. */
(function () {
  if (window.__ovrGallery) return;
  window.__ovrGallery = true;

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var ICON = {
    prev: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5 8 12l7 7"/></svg>',
    next: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 5 7 7-7 7"/></svg>',
    close: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>',
    zoom: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="6.5"/><path d="m16 16 4.5 4.5M11 8.5v5M8.5 11h5"/></svg>'
  };

  /* Shopify image URLs take their size from a width parameter. The page loads
     the picture at 1200; the enlarged view asks for 2000, the thumbnails 160. */
  function sized(url, w) {
    if (!url) return url;
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&])width=\d+/, '$1width=' + w);
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html) n.innerHTML = html;
    return n;
  }

  /* ---------------- The enlarged view ---------------- */

  var box = null;
  var boxImgs = [];
  var boxAt = 0;
  var boxOnClose = null;

  function lock(on) { document.documentElement.style.overflow = on ? 'hidden' : ''; }

  function ensureBox() {
    if (box) return box;
    box = el('dialog', 'galbox');
    box.setAttribute('aria-label', 'Enlarged product image');
    box.innerHTML =
      '<div class="galbox__bar"><span data-gb-count></span>' +
      '<button type="button" data-gb-close aria-label="Close">' + ICON.close + '</button></div>' +
      '<button type="button" class="galbox__nav galbox__nav--prev" data-gb-prev aria-label="Previous image">' + ICON.prev + '</button>' +
      '<div class="galbox__stage"><img class="galbox__img" alt="" data-gb-img></div>' +
      '<button type="button" class="galbox__nav galbox__nav--next" data-gb-next aria-label="Next image">' + ICON.next + '</button>';
    document.body.appendChild(box);

    box.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-gb-close]')) { closeBox(); return; }
      if (t.closest('[data-gb-prev]')) { step(-1); return; }
      if (t.closest('[data-gb-next]')) { step(1); return; }
      /* Anywhere that is not the picture itself is the dark around it. */
      if (!t.closest('[data-gb-img]')) closeBox();
    });
    box.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
    });
    /* The page is unlocked on every close path directly: the `close` event is
       queued, and a page left scroll-locked would be worse than a slow unlock. */
    box.addEventListener('cancel', function () { lock(false); sync(); });
    box.addEventListener('close', function () { lock(false); sync(); });

    /* A swipe, for a thumb. */
    var x0 = null;
    box.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      x0 = null;
      if (Math.abs(dx) > 50) step(dx < 0 ? 1 : -1);
    }, { passive: true });
    return box;
  }

  function paintBox() {
    var img = box.querySelector('[data-gb-img]');
    var cur = boxImgs[boxAt];
    img.src = cur.big;
    img.alt = cur.alt;
    box.querySelector('[data-gb-count]').textContent = (boxAt + 1) + ' / ' + boxImgs.length;
    var many = boxImgs.length > 1;
    var p = box.querySelector('[data-gb-prev]');
    var n = box.querySelector('[data-gb-next]');
    p.hidden = !many;
    n.hidden = !many;
    p.disabled = boxAt === 0;
    n.disabled = boxAt === boxImgs.length - 1;
  }

  function step(dir) {
    var n = boxAt + dir;
    if (n < 0 || n >= boxImgs.length) return;
    boxAt = n;
    paintBox();
  }

  /* Leave the slideshow on whichever picture was last looked at. */
  function sync() { if (boxOnClose) boxOnClose(boxAt); }

  function closeBox() {
    if (box && box.open) box.close();
    lock(false);
  }

  function openBox(list, at, onClose) {
    ensureBox();
    boxImgs = list;
    boxAt = at;
    boxOnClose = onClose;
    paintBox();
    if (typeof box.showModal === 'function') box.showModal();
    else box.setAttribute('open', '');
    lock(true);
    var c = box.querySelector('[data-gb-close]');
    if (c) c.focus({ preventScroll: true });
  }

  /* ---------------- The slideshow ---------------- */

  function build(root) {
    if (root.__ovrGal) return;
    var shots = root.querySelectorAll('.pdp__shot img');
    if (!shots.length) return;          // technical flats stand in until there are photos
    root.__ovrGal = true;

    var items = [];
    for (var i = 0; i < shots.length; i++) {
      var s = shots[i];
      var u = s.getAttribute('src') || '';
      items.push({
        src: u,
        srcset: s.getAttribute('srcset') || '',
        alt: s.getAttribute('alt') || '',
        thumb: sized(u, 160),
        big: sized(u, 2000)
      });
    }
    var many = items.length > 1;

    var stage = el('div', 'gal__stage');
    var track = el('div', 'gal__track');
    track.setAttribute('role', 'group');
    track.setAttribute('aria-label', 'Product images');

    var slides = [];
    for (var j = 0; j < items.length; j++) {
      var b = el('button', 'gal__slide');
      b.type = 'button';
      b.setAttribute('aria-label', 'Enlarge image ' + (j + 1) + ' of ' + items.length);
      var im = el('img');
      im.src = items[j].src;
      if (items[j].srcset) im.srcset = items[j].srcset;
      im.sizes = '(max-width: 900px) 100vw, 48vw';
      im.alt = items[j].alt;
      im.decoding = 'async';
      if (j > 0) im.loading = 'lazy';
      b.appendChild(im);
      track.appendChild(b);
      slides.push(b);
    }
    stage.appendChild(track);
    stage.appendChild(el('span', 'gal__hint', ICON.zoom));

    var prev = null, next = null, count = null, thumbs = null, thumbBtns = [];
    if (many) {
      prev = el('button', 'gal__arrow gal__arrow--prev', ICON.prev);
      prev.type = 'button';
      prev.setAttribute('aria-label', 'Previous image');
      next = el('button', 'gal__arrow gal__arrow--next', ICON.next);
      next.type = 'button';
      next.setAttribute('aria-label', 'Next image');
      count = el('span', 'gal__count');
      count.setAttribute('aria-hidden', 'true');
      stage.appendChild(prev);
      stage.appendChild(next);
      stage.appendChild(count);

      thumbs = el('div', 'gal__thumbs');
      for (var k = 0; k < items.length; k++) {
        var t = el('button', 'gal__thumb');
        t.type = 'button';
        t.setAttribute('aria-label', 'Show image ' + (k + 1));
        var ti = el('img');
        ti.src = items[k].thumb;
        ti.alt = '';
        ti.loading = 'lazy';
        t.appendChild(ti);
        thumbs.appendChild(t);
        thumbBtns.push(t);
      }
    }

    root.textContent = '';
    root.appendChild(stage);
    if (thumbs) root.appendChild(thumbs);
    root.classList.add('is-gal');

    var at = 0;
    function width() { return track.clientWidth || 1; }
    function paint(i) {
      at = i;
      if (count) count.textContent = (i + 1) + ' / ' + items.length;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === items.length - 1;
      for (var n = 0; n < thumbBtns.length; n++) {
        thumbBtns[n].setAttribute('aria-current', n === i ? 'true' : 'false');
      }
    }
    function go(i, instant) {
      if (i < 0 || i >= items.length) return;
      track.scrollTo({ left: i * width(), behavior: (REDUCED || instant) ? 'auto' : 'smooth' });
      paint(i);
    }

    var tick = null;
    track.addEventListener('scroll', function () {
      if (tick) return;
      tick = requestAnimationFrame(function () {
        tick = null;
        var i = Math.round(track.scrollLeft / width());
        if (i !== at && i >= 0 && i < items.length) paint(i);
      });
    }, { passive: true });

    if (prev) prev.addEventListener('click', function () { go(at - 1); });
    if (next) next.addEventListener('click', function () { go(at + 1); });
    thumbBtns.forEach(function (tb, n) { tb.addEventListener('click', function () { go(n); }); });

    slides.forEach(function (sl, n) {
      sl.addEventListener('click', function () {
        openBox(items, n, function (last) { go(last, true); });
      });
    });

    /* The arrow keys move the slideshow when focus is inside it. */
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { go(at - 1); }
      else if (e.key === 'ArrowRight') { go(at + 1); }
    });

    window.addEventListener('resize', function () { go(at, true); });
    paint(0);
  }

  function init() {
    var roots = document.querySelectorAll('.ovr .pdp__gallery');
    for (var i = 0; i < roots.length; i++) {
      try { build(roots[i]); } catch (err) { console.error('[ovr] gallery failed', err); }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
